export interface FocusableElement {
	focus(): Promise<void>;
}
